/**
 * @generated SignedSource<<e4ff6cb9f33df6a6d42cdaa14fa8474b>>
 * @relayHash 8562b941e006349bc8738830b321042b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2ae00a3218acc4eb48196377d656d9cc69916c593cb4f244772e9202720dc8b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AnalyticsDashboardEditableQuery } from './AnalyticsDashboardEditableQuery.graphql';

const node: PreloadableConcreteRequest<AnalyticsDashboardEditableQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d2ae00a3218acc4eb48196377d656d9cc69916c593cb4f244772e9202720dc8b",
    "metadata": {},
    "name": "AnalyticsDashboardEditableQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
